import { FieldMetaState } from 'react-final-form';

export const checkFieldError = (meta: FieldMetaState<string>): boolean | undefined =>
  meta.touched && meta.invalid && (Boolean(meta.error) || Boolean(meta.submitError));
